<template>
  <iframe src="/customs.html"></iframe>
</template>

<script>
export default {
  name: 'customs'
}
</script>
<style lang="less" scoped>
iframe {
  width: 100%;
  height: 2700px;
}
</style>
